import Alert from '@mui/material/Alert';

import type { DashboardData } from './dashboardData';

/**
 * Says the numbers are examples, where every viewer sees it - in a demo, in a
 * screenshot - so nobody takes them for the organization's own. It covers
 * every card and table beneath it, and goes away by itself once the source is
 * live.
 */
export function SampleDataNotice({ source }: { source: DashboardData['source'] }) {
  if (source !== 'sample') return null;

  return (
    <Alert severity="info" role="status" sx={{ mb: 3 }}>
      <strong>Sample data.</strong> These are example numbers. Your organization&rsquo;s
      own figures appear here once the analytics service is running.
    </Alert>
  );
}
